import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import {
    Box,
    Grid,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    Typography,
    MenuItem,
} from "@mui/material";
import styles from "../../../styles.module.css";
import sales_order from "../../../services/sales_order";
import { Breadcrumb, CTSinput, SearchInput, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection"; // Adjusted import path
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const Monthly_Logistics_Report = () => {
    const defaultRowsPerPage = useSelector((state) => state.sales_order?.rows_per_page || 15);
    const totalCount = useSelector((state) => state.pickup_entry?.total_count || 0);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage,
    });
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState("");
    const [successMessage, setSuccessMessage] = useState(null);

    const fields = ["customer_name"];
    const labels = ["Customer Name"];

    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await sales_order.getpendingSalesorder(params);
            const dataArray = Array.isArray(response) ? response : response.data || [response];
            setRows(dataArray.map((row) => ({ ...row })));
        } catch (error) {
            console.error("Error in fetchData:", error);
            setSuccessMessage("Error fetching data");
        }
    };

    const sortedRows = useMemo(() => {
        return [...rows].sort((a, b) => {
            const dateA = a.po_date ? new Date(a.po_date) : new Date();
            const dateB = b.po_date ? new Date(b.po_date) : new Date();
            return dateB - dateA;
        });
    }, [rows]);

     const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


    const handleChangePage = (event, newPage) => {
        setController((prev) => ({ ...prev, page: newPage }));
    };

    const handleChangeRowsPerPage = (event) => {
        setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
    };

    const handleSearch = (e) => {
        setSearchKey(e.target.value);
        setController((prev) => ({ ...prev, page: 0 }));
    };

    useEffect(() => {
        fetchData();
    }, [controller, searchKey]);

    return (
        <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={styles.body}>
                <Breadcrumb routeSegments={[{ name: "Monthly Logistics Report" }]} />

                <HeaderSection
                    title="Monthly Logistics Report"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Monthly Logistics Report"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />

                <Grid container spacing={1}>
                

                    <Grid item xs={12}>
                        <Paper sx={{ width: "100%", overflow: "hidden" }}>
                            <TableContainer component={Paper} className={styles.list_tbl_container}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align="left" className={styles.table_head}>Vehicle No</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Driver</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Product Name</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Qty Delivered</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Cylinders Delivered</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Empty Cylinder Collected</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Total KMs Travelled</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Total Fuel Consumption</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Target Fuel Eff</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Actual Fuel Eff</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Total Expenses</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Delivery Cost Per Unit Product</StyledTableCell>
                                            <StyledTableCell align="left" className={styles.table_head}>Remarks</StyledTableCell>
                                        </StyledTableRow>

                                    </TableHead>




                                    <TableBody sx={{ backgroundColor: '#ffffff' }}>
                                        {Array.isArray(sortedRows) && sortedRows.length > 0 ? (
                                            sortedRows.map((row, index) => (
                                                <StyledTableRow key={row.sales_order_id || index}>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.cylinder_no || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.customer_name || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.prod_code || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.delivered_on || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.issue_depot || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.vehicle_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.dc_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.invoice_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.invoice_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.vehicle_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.dc_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.invoice_no_delivery || "-"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" className={styles.list_table_body}>
                                                        {row.invoice_no_delivery || "-"}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={16} align="center">
                                                    No data available
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>


                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={() => setSuccessMessage(null)}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default Monthly_Logistics_Report;
